<template>
  <div class="page-template clear-data" v-loading="loading">
    <div class="page-title">{{title}}</div>
    <div class="page-edit">
        <div class="cue">操作将针对一下选项，物理删除所有门店数据库数据，且不可恢复，请谨慎操作！</div>
        <div class="check-list-box">
            <div class="check-all">清理业务数据</div>
            <div class="check-list">
                <el-checkbox v-for="item in checkList" v-model="item.checked"
                             :key="item.id||item.value||item[column.key]"
                             :label="item.name||item.label||item[column.value]"></el-checkbox>
            </div>
            <div class="cl"></div>
        </div>
        <div class="agreement">
          <el-checkbox v-model="agreement"></el-checkbox>&nbsp;&nbsp;我已阅读并同意<a  href="/system/maintain/agreement">《店播.嘉维斯业务数据清理协议》</a>
        </div>
        <div class="btn-box">
          <el-button @click="submit">提交</el-button>
        </div>
    </div>
  </div>
</template>
<script>
  import api from "@/config/api";

  export default {
    data() {
      return {
        loading:false,
        title: '',
        checkList:[],
        agreement:false
      };
    },
    created() {
      this.title = document.title;
      this.getSysJurisdiction();
    },
    methods: {
      getSysJurisdiction(){
        this.$axios.fetchPost(api.system.sysJurisdiction, {type:90}).then(data => {
            if(data.code == 200 && data.data){
              data.data.map(item => {
                 item.checked = false;
              });
              this.checkList = data.data;
            }
        });
      },
      submit() {
        if(!this.agreement){
          this.$message({type: 'warning', message: '请先勾选协议!'});
          return;
        }
        let checkedList = [];
        this.checkList.map(item=>{
          if(item.checked)checkedList.push(item);
        });
        if(checkedList.length==0){
          this.$message({type: 'warning', message: '请选择清除项!'});
          return;
        }
        this.loading = true;
        this.$axios.fetchPost(api.system.businessClear, checkedList).then(data => {
          this.loading = false;
            if(data.code == 200){
              this.$notify({
                type: "success",
                title: '清理操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({type: 'success', message: '清理成功!'});
                this.checkList.map(item=>{
                  item.checked = false;
                });
                this.agreement = false;
            }else{
              this.$notify({
                type: "error",
                title: '清理操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({type: 'error', message: '清理失败!'});
            }
        });
      }
    }
  };
</script>
<style scoped>
.clear-data .cue{
  height: 40px;
  line-height: 40px;
  color:#efa666;
  background-color: #fdf6ec;
  padding:0 20px;
}
.clear-data .check-list-box{
  padding:20px;
}
.clear-data .check-list-box .check-list .el-checkbox {
  width: 33%;
  margin-bottom: 10px;
}
.clear-data .check-list-box .check-all {
  float: left;
  width: 140px;
}

.clear-data .check-list-box .check-list {
  float: left;
  width: calc(100% - 140px);
}
.clear-data .agreement{
  color:#5e57e3;
}
.clear-data .agreement a{
  color:#5e57e3;
}
.clear-data .agreement a:hover{
  color: red;
}
.clear-data .btn-box{
  margin-top:20px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/page/system/maintain/Data.vue